<template>
    <div>
        <a-row>
            <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 22, offset: 1 }">
                <a-row>
                    <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 14 }" :lg="{ span: 14 }">
                        <a-list class="mb-20" item-layout="horizontal">
                            <a-list-item>
                                <a-list-item-meta>
                                    <div slot="title">
                                        <h5 class="mt-10 mb-10 font-weight-bold" style="color: #000000 !important;">
                                            Overview
                                        </h5>
                                    </div>
                                    <div slot="description">
                                        <a-list item-layout="horizontal" :data-source="dataFeature">
                                            <a-list-item slot="renderItem" slot-scope="item, index">
                                                <a-list-item-meta>
                                                    <div slot="description" class="font-web" v-html="item.detail"></div>
                                                    <p class="m-0" style="font-size: 18px;" slot="title">{{ item.title }}
                                                    </p>
                                                    <a-avatar :style="{ backgroundColor: '#610C9F' }" slot="avatar"
                                                        shape="square" :size="45" :icon="item.src" />
                                                </a-list-item-meta>
                                            </a-list-item>
                                        </a-list>
                                    </div>
                                </a-list-item-meta>
                            </a-list-item>
                        </a-list>
                    </a-col>
                    <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 10 }" :lg="{ span: 10 }">
                        <a-carousel autoplay arrows :autoplaySpeed="3000">
                            <div class="mb-20">
                                <MobileFrame title="Overview" name="bg-01" />
                            </div>
                            <div class="mb-20">
                                <MobileFrame title="Overview" name="bg-02" />
                            </div>
                            <div class="mb-20">
                                <MobileFrame title="Overview" name="bg-03" />
                            </div>
                            <div class="mb-20">
                                <MobileFrame title="Overview" name="bg-04" />
                            </div>
                        </a-carousel>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import MobileFrame from '../MobileFrame.vue';

const dataFeature = [
    {
        title: 'Home',
        src: 'appstore',
        detail: 'ข่าวสาร และประกาศต่างๆจากทาง Application',
    },
    {
        title: 'IC Meal',
        src: 'wallet',
        detail: 'สวัสดิการเงินช่วยเหลือค่าอาหารรายเดือน โดยวิทยาลัย',
    },
    {
        title: 'Calendar',
        src: 'calendar',
        detail: 'เมนูปฏินทินของวิทยาลัย',
    },
    {
        title: 'Profile',
        src: 'user',
        detail: 'E-card for Staff MUIC',
    },
    {
        title: 'Notification',
        src: 'bell',
        detail: 'การแจ้งเตือนจาก Application กรณีมี Event ในการดำเนินการกิจกรรมต่าง ๆ',
    },
    {
        title: 'Setting',
        src: 'setting',
        detail: 'ตั้งค่า Application ให้เหมาะสมกับการใช้งานของท่าน',
    },
];

export default {
    components: {
        MobileFrame,
    },
    data() {
        return {
            dataFeature,
        }
    }
}
</script>

<style scoped>
/* For demo */
.ant-carousel>>>.slick-slide {
    /* text-align: center;
    line-height: 160px;
    background: #ffffff; */
    /* height: 55vh; */
    /* border-radius: 10px; */
    /* padding: 25px; */
    /* background: #EEEEEE; */
    overflow: hidden;
}

.ant-carousel>>>.custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #f40909;
    background-color: rgba(31, 45, 61, 0.11) !important;
    opacity: 0.3;
}

.ant-carousel>>>.custom-slick-arrow:before {
    display: none;
}

.ant-carousel>>>.custom-slick-arrow:hover {
    opacity: 1;
    background-color: rgba(31, 45, 61, 0.11);
}

.ant-carousel>>>.slick-slide h3 {
    color: #000000;
}
</style>